import { Route, Routes, useNavigate} from 'react-router-dom';
import { StandardViewPanel } from '../../../_components/panel/standardView.panel';
import { getDateString } from '../../../_helpers/dateTime.helper';
import { ClientDetailsManageDrawer } from './client-detailsManageDrawer';



export const ClientDetailsPanel = ({ data, isLoading, onRefresh }: any) => {
    const navigate = useNavigate();

    const rows = [
        { label: 'First Name:', value: data.fName },
        { label: 'Last Name:', value: data.lName },
        { label: 'Distinguishing Features:', value: data.distinguishingFeatures },
        { label: 'Email', value: data.email },
        { label: 'Phone', value: data.phone },
        { label: 'Mobile', value: data.mobilePhone },
        { label: 'Nickname', value: data.nickname },
        { label: 'Gender', value: data.genderName },
        { label: 'DOB', value: getDateString(data.dob) },
        { label: 'PPSN', value: data.ppsn },
        { label: 'Height(cm)', value: data.height },
        { label: 'Weight(kg)', value: data.weight },
        { label: 'Body Type', value: data.bodyTypeName },
        { label: 'Eye Colour', value: data.eyeColourName },
        { label: 'Hair Colour', value: data.hairColourName },
        { label: 'Ethnic Origin', value: data.ethnicOriginName },
        { label: 'Complexion', value: data.complexionName },


    ]

    return (
        <>
            <StandardViewPanel
                title={`Client Details For ${data.fName} ${data.lName}`} buttons={[
                    { icon: "edit", onClick: () => { navigate("ManageDetails/") } }
                ]}
                loading={isLoading}
                items={rows} />

            <Routes>
                <Route path="ManageDetails/" element={<ClientDetailsManageDrawer onSave={() => { navigate(""); onRefresh(); }} onClose={() => { navigate(""); onRefresh(); }} />} />
            </Routes>
        </>
    );
};